export const facebookUri = 'https://www.facebook.com/people/Bufet-Prestige/100063754220656/?rdid=kKw09bjnuDEBqSq3';